import { Modelo } from '@ext/index';
import * as Types from './Observacion.types';
import moment, { Moment } from 'moment';

export class IObservacion extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Pedido: number = 0;
    public Observacion: string = '';
    public Fecha: Moment = moment();
    public Usuario = {
        Nombre: '',
        Apellido: '',
        NickName: '',
    };
    public get NombreCompleto()
    {
        return ( this.Usuario.Nombre ? this.Usuario.Nombre : '' ) +' '+ ( this.Usuario.Apellido ? this.Usuario.Apellido : '' )
    }

    public getJson(): any {
        let json: any = {};

        json.pedido = this.Pedido;
        json.observacion = this.Observacion;

        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Pedido = !this.Json.pedido ? 0 : this.Json.pedido;
        this.Observacion = !this.Json.observacion ? '' : this.Json.observacion;
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.Usuario.Nombre = this.Json.usuario?.nombre;
        this.Usuario.Apellido = this.Json.usuario?.apellido;
        this.Usuario.NickName = this.Json.usuario.usuario;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IObservacion ) {
        this.Model = Model;
    }

    public Model: IObservacion;
}